import React from "react"
import styles from "./styles.scss"
import FaIcon from "@fortawesome/react-fontawesome"
import Tooltip from "./Tooltip"
import cx from "classnames"

class Step extends React.PureComponent {
  handleHover = () => this.props.onHover(this.props.step.id)

  render() {
    const { step, angle, isActive, iconWidth } = this.props

    return (
      <Tooltip text={step.title} style={{ transform: `rotate(${angle}deg)` }}>
        <div
          className={cx(styles.item, { [styles.active]: isActive })}
          onMouseEnter={this.handleHover}
          style={{ width: iconWidth, height: iconWidth }}
        >
          <FaIcon icon={step.icon} />
        </div>
      </Tooltip>
    )
  }
}

export default Step



// WEBPACK FOOTER //
// ./src/pages/LandingPage/Chart/DiagonalLine/Step/index.jsx